import format from 'date-fns/format'
import { es } from 'date-fns/locale'
import * as moment from 'moment'
const MASK = 'dd/MM/yyyy'

export const dateToString = (date, mask = MASK) => {
  if (!date) return ''
  if (date instanceof Date) return format(date, mask, { locale: es })
  if (date instanceof String || typeof date === 'string') {
    if (date.indexOf(':') > 0) date = new Date(date)
    else date = new Date(`${date} 00:00:00`)

    if (date instanceof Date && !isNaN(date))
      return format(date, mask, { locale: es })
  }

  return ''
}

export const stringToDate = str => {
  return new Date(str)
}

export const formatStringDate = (str, mask = MASK) => {
  return dateToString(stringToDate(str), mask)
}

// New
const getDate = date => {
  if (!date) return null

  if (
    typeof date !== 'string' ||
    date.indexOf('T') > 0 ||
    date.indexOf(':') > 0
  )
    return date

  return `${date}T00:00:00.000-06:00`
}

export const currency = value => {
  if (value) return `Q ${value.toFixed(2)}`

  return 'Q 0'
}

export const formatDate = date => {
  const _date = new Date(getDate(date))
  return `${_date.getDate()} ${month(date)} ${_date.getFullYear()}`
}

export const formatMonthDate = date => {
  const _date = new Date(getDate(date))
  return `${month(date)} ${_date.getFullYear()}`
}

export const felFormatDate = date => {
  const _date = new Date(getDate(date))
  const monthN = _date.getMonth() + 1
  return `${_date.getDate()}/${monthN}/${_date.getFullYear()} ${_date.getHours()}:${_date.getMinutes()}`
}

export const month = date => {
  const m = new Date(getDate(date)).getMonth()

  if (m === 0) return 'Enero'
  if (m === 1) return 'Febrero'
  if (m === 2) return 'Marzo'
  if (m === 3) return 'Abril'
  if (m === 4) return 'Mayo'
  if (m === 5) return 'Junio'
  if (m === 6) return 'Julio'
  if (m === 7) return 'Agosto'
  if (m === 8) return 'Septiembre'
  if (m === 9) return 'Octubre'
  if (m === 10) return 'Noviembre'
  if (m === 11) return 'Diciembre'

  return ''
}

export const abbrMonth = date => {
  const m = new Date(getDate(date)).getMonth()

  if (m === 0) return 'Ene'
  if (m === 1) return 'Feb'
  if (m === 2) return 'Mar'
  if (m === 3) return 'Abr'
  if (m === 4) return 'May'
  if (m === 5) return 'Jun'
  if (m === 6) return 'Jul'
  if (m === 7) return 'Ago'
  if (m === 8) return 'Sep'
  if (m === 9) return 'Oct'
  if (m === 10) return 'Nov'
  if (m === 11) return 'Dic'

  return ''
}

export const felItemDate = date => {
  return `${abbrMonth(new Date(getDate(date)))} ${new Date(
    getDate(date)
  ).getFullYear()}`
}

export const getItemDescription = sale =>
  `Servicios ${felItemDate(sale.postingDate)}    `

export const felCurrency = value =>
  value && !isNaN(parseFloat(value)) ? value.toFixed(2) : '0.00'


export const transformDate = (date) => {
  const fechaOriginal = new Date(date);

  // Obtener la diferencia en minutos entre UTC y UTC-6
  const diferenciaUTC_6 = -6 * 60; // UTC-6

  // Aplicar la diferencia horaria
  const fechaUTC_6 = new Date(fechaOriginal.getTime() + (diferenciaUTC_6 * 60000)); // 60000 milisegundos en un minuto

  // Formatear la fecha en el formato deseado (yyyy-mm-dd HH:mm:ss)
  const fechaFormateada = fechaUTC_6.toISOString().replace('T', ' ').replace(/\.\d+Z$/, '');
  return fechaFormateada
}

export const limitDate = (date) => {
  const fechaInput = moment(date);
  // Obtenemos la fecha actual
  const fechaActual = moment();
  //console.log(fechaInput)
  //console.log('fecha_actual', fechaActual)
  //if (!fechaInput.isValid()) return false;

  const fechaLimite = moment().subtract(5, 'days')
  return fechaInput.isBetween(fechaLimite, fechaActual, undefined, '[]')
}




export const formatDateFel = (date1, date2, mask = 'YYYY-MM-DDTHH:mm:ss') => {
  // Extraer la fecha de posting_date
  let datePart = date1; // solo la fecha

  let timePart

  if (typeof date2 === 'object') {
    const tmp = moment(date2).format('YYYY-MM-DDTHH:mm:ss')//(date2)
    timePart = tmp.split('T')[1];


  }

  if (typeof date2 === 'string') {
    timePart = date2.split('T')[1];
  }

  // Extraer la hora de create_at

  // Combinar ambos
  let date = `${datePart}T${timePart}`;
  return date
  //return moment(date).format(mask)
}
